import { Minus, Plus } from 'lucide-react';
import { cn } from '@/lib/utils';

// Quantity stepper (− / number input / +) used on catalog cards. The numeric
// input accepts typed values (including fractional, e.g. 0.5 lb) while the
// buttons increment in whole steps.
export function QuantityStepper({
  value,
  onChange,
  className,
  disabled,
}: {
  value: number;
  onChange: (next: number) => void;
  className?: string;
  disabled?: boolean;
}) {
  return (
    <div
      className={cn(
        'inline-flex items-center overflow-hidden rounded-card border border-line',
        disabled && 'pointer-events-none opacity-40',
        className,
      )}
      aria-disabled={disabled}
    >
      <button
        type="button"
        aria-label="Decrease quantity"
        className="flex h-11 w-11 items-center justify-center text-brand hover:bg-surface-2 active:bg-surface-3 disabled:opacity-40 sm:h-8 sm:w-8"
        disabled={disabled || value <= 0}
        onClick={() => onChange(Math.max(0, value - 1))}
      >
        <Minus className="h-4 w-4" />
      </button>
      <input
        type="number"
        inputMode="decimal"
        min={0}
        step="any"
        value={value === 0 ? '' : value}
        placeholder="0"
        aria-label="Quantity"
        disabled={disabled}
        enterKeyHint="done"
        onFocus={(e) => e.currentTarget.select()}
        className="h-11 w-14 border-x border-line bg-transparent sm:h-8 text-center text-sm text-ink focus:bg-brand/10 focus:outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
        onChange={(e) => {
          const parsed = Number.parseFloat(e.target.value);
          onChange(Number.isNaN(parsed) ? 0 : parsed);
        }}
      />
      <button
        type="button"
        aria-label="Increase quantity"
        disabled={disabled}
        className="flex h-11 w-11 items-center justify-center text-brand hover:bg-surface-2 active:bg-surface-3 sm:h-8 sm:w-8"
        onClick={() => onChange(value + 1)}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
}
